/* REBUY SNIPPETS */

document.querySelector('.carticonlink').addEventListener('click', () => {
  Rebuy.SmartCart.show();
});

/*
document.querySelector('#CartDrawer #CloseCart').click();
*/


// Main Menu - top level items # link
document.addEventListener('DOMContentLoaded', function () {
  // Select all anchor links in the main menu with href="#"
  const menuLinks = document.querySelectorAll('nav a[href="#"]');

  menuLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault(); // prevent page reload/jump
    });
  });
});


